import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { updateHorse } from '../actions/horseActions';

export default function Favorite ({ horse, color='#7a0f23', ...props }) {
    const {
        favorited = false,
    } = horse;
    const icon = favorited ? ['fas', 'heart'] : ['far', 'heart'] ;

    const dispatch = useDispatch()
    const toggleFavorited = useCallback(
      () => dispatch(updateHorse({
          ...horse,
          favorited: !favorited,
      })),
      [dispatch, favorited, horse]
    )
    return (
        <div {...props} className="favorite">
            <button className="btn btn-link"  onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggleFavorited()}} >
                <FontAwesomeIcon style={{ color: color, verticalAlign:"middle" }} icon={icon} />
            </button>
        </div>
    )
}